import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div<{ mode: 'dark' | 'light' }>`
	max-width: 1420px;
	margin: 0 auto;
	position: relative;

	background-color: ${(props) =>
		props.mode === 'light' ? CSSVars.gray100 : CSSVars.gray700};
	border-radius: 10px;
	color: ${(props) =>
		props.mode === 'light' ? CSSVars.gray900 : CSSVars.white};
	display: flex;
	align-items: center;
	gap: 10px;

	padding: 30px;
	flex-direction: column;

	img {
		max-width: 100%;
		height: 100%;
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		gap: 30px;
		flex-direction: row;
	}

	@media screen and (min-width: ${CSSVars.breakpointXL}) {
		padding: 50px 120px;
	}

	&.developers-banner {
		background-color: #fff;
		background: linear-gradient(90deg, #3a51af 0%, #798fe9 100%);
	}

	&.more-padding {
		padding: 30px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 40px 60px;
		}

		@media screen and (min-width: ${CSSVars.breakpointXL}) {
			padding: 100px 120px;
		}
	}

	.text-wrapper {
		h3 {
			font-weight: 600;
			font-size: ${CSSVars.fontSize2XL};
			max-width: 700px;
			z-index: 10;
			position: relative;

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize4XL};
			}
		}

		p {
			font-weight: 300;
			font-size: ${CSSVars.fontSizeMD};
			z-index: 10;
			position: relative;
			margin: 20px 0;

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				margin: 30px 0;
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		a {
			font-weight: 600;
			color: ${CSSVars.white};
			display: flex;
			align-items: center;
			gap: 20px;
			font-size: ${CSSVars.fontSizeLG};
			width: fit-content;

			.icon {
				padding-top: 2px;
			}

			&:hover {
				opacity: 0.8;
				text-decoration: underline;
			}
		}
	}
`;
